export default __webpack_public_path__ + "static/media/bathroom1-before-2048w.136edce2.avif";